import React, { Component } from 'react'
import Breadcrumb from '../../components/uielements/breadcrumb'

import { Link } from 'react-router-dom'

class BreadCrumbComponent extends Component {
    render() {
        return (
            <Breadcrumb>
                <Breadcrumb.Item>
                    <span to="dashboard" className="breadcrumbTitle">Category</span>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                    <span className="breadcrumbTitle">Organization</span>
                </Breadcrumb.Item>
            </Breadcrumb>
        )
    }
}

export default BreadCrumbComponent
